import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { WindowService } from './window.service';

@Injectable({
  providedIn: 'root'
})
export class PaymentStatusReturnService implements CanActivate {
  constructor(private windowService: WindowService) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    const status = route.paramMap.get('status');
    this.windowService.nativeWindow.parent.postMessage(
      {
        event_id: 'redirect',
        status: status
      }
      ,
      '*'
    );
    return false;
  }
}
